import { memo } from "react";
import { Close as CloseIcon } from "components/icon/mui_icon";
import { DialogTitle, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

const DialogTitleUi = (props) => {
  const { title, clickEvent } = props;
  const { t } = useTranslation();
  return (
    <DialogTitle sx={{ m: 0, p: 2 }}>
      {title}
      <IconButton
        sx={{ position: "absolute", top: 13, right: 16 }}
        onClick={clickEvent}
        aria-label={t("close")}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default memo(DialogTitleUi);
